// src/js/index.js
import { stickyHeader } from './header';
document.addEventListener('DOMContentLoaded', function () {
  stickyHeader();
});